const Poppet = (level, summoner) => {
  const handle = 'poppet';
  const types = ['humanoid', 'poppet'];
  const bags = [{ items: Object.values(summoner.equipment).map((item) => ({ value: item })) }];
  const ai_priorities = ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'];

  return {
    handle,
    types,
    level,
    getAbilityTrees: () => [
      {
        handle: 'poppet_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
        },
      },
    ],
    getBaseAttributes: () => {
      const { base, fromUpgrades, fromEquipment, fromConditions } = summoner.attributes;
      return {
        learning: Math.round(
          (base.learning +
            fromUpgrades.learning +
            fromEquipment.learning +
            fromConditions.learning) *
            level *
            0.1
        ),
        perception: Math.round(
          (base.perception +
            fromUpgrades.perception +
            fromEquipment.perception +
            fromConditions.perception) *
            level *
            0.1
        ),
        mana: Math.round(
          (base.mana + fromUpgrades.mana + fromEquipment.mana + fromConditions.mana) * level * 0.1
        ),
        toughness: Math.round(
          (base.toughness +
            fromUpgrades.toughness +
            fromEquipment.toughness +
            fromConditions.toughness) *
            level *
            0.1
        ),
        strength: Math.round(
          (base.strength +
            fromUpgrades.strength +
            fromEquipment.strength +
            fromConditions.strength) *
            level *
            0.1
        ),
        willpower: Math.round(
          (base.willpower +
            fromUpgrades.willpower +
            fromEquipment.willpower +
            fromConditions.willpower) *
            level *
            0.1
        ),
        dexterity: Math.round(
          (base.dexterity +
            fromUpgrades.dexterity +
            fromEquipment.dexterity +
            fromConditions.dexterity) *
            level *
            0.1
        ),
      };
    },
    getDefaultAIConfig: () => ai_priorities,
    getStarterEquipment: () => {},
    bags,
    build: {
      ai: {
        priorities: ai_priorities,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      beast: false,
      equipment_assignment: summoner.equipment_assignment,
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }],
      faux_self: true,
      handle,
      hero: true,
      humanoid: true,
      level,
      poppet: true,
      team: summoner.team,
      types,
      undead: false,
      unit: true,
    },
  };
};
module.exports = Poppet;
